import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { colors } from '@config/colors';
import { blur, borderRadius, spacing } from '@config/spacing';
import { typography } from '@config/typography';
import { app } from '@config/constants';
import { AppRouter } from '@routes/app-router';
import { WaterBackground } from '@components/water';
import { WaterStoryProvider } from '@components/water/water-story';

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  :root {
    --glass-blur: ${blur.glass};
    --glass-radius: ${borderRadius['2xl']};
    --glass-shadow-soft: 0 18px 40px ${colors.shadowSoft};
    --glass-shadow-hard: 0 8px 24px ${colors.shadowHard};
    --max-content-width: ${app.maxContentWidth};
    --page-horizontal-padding: ${spacing.lg};
  }

  /* overflow-x: clip (not hidden) — hidden makes html/body a scroll
     container, which breaks position: sticky for descendants relative to
     the viewport. clip clips overflow without creating a scroll container. */
  html, body {
    overflow-x: clip;
  }

  body {
    font-family: ${typography.fontFamily.body};
    font-weight: 300;
    color: ${colors.text};
    /* The water's mean colour: what shows before it paints, and past the
       page's edges when a scroll overshoots. */
    background: ${colors.wee.page};
    position: relative;
    color-scheme: light;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${typography.fontFamily.heading};
    font-weight: 300;
    line-height: ${typography.lineHeight.headingTight};
  }

  a {
    color: inherit;
    text-decoration: none;
  }
`;

const App: React.FC = () => (
  <WaterStoryProvider>
    <GlobalStyle />
    <WaterBackground />
    <AppRouter />
  </WaterStoryProvider>
);

export default App;
